import { type MenuItemProps } from '@progress/kendo-react-layout'
import classNames from 'classnames'
import React from 'react'

import { Icon } from '~/components/elements/Icon'
import { exists, type IconName } from '~/utils'

import styles from './HeaderMenu.css'

type MenuItemRenderContentProps = {
  item: Omit<MenuItemProps, 'data'> & {
    data: {
      icon?: IconName
      isActive?: boolean
    }
  }
  itemId: string
}

export const MenuItemRenderContent = ({
  item: { data, text },
  itemId,
}: MenuItemRenderContentProps) => {
  const isSubItem = itemId.split('_').length === 2

  const content = (
    <>
      {exists(data.icon) && <Icon icon={data.icon} size="1.25rem" />}

      {exists(text) && (
        <span
          className={classNames(styles.text, isSubItem && styles.subItemText)}
        >
          {text}

          {data.isActive && <Icon icon="check" size="1rem" />}
        </span>
      )}
    </>
  )

  return content
}
